/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Even_Top_Javelina_JumpInputs */

const fr_even_top_javelina_jump = /** @type {(inputs: Even_Top_Javelina_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sauvegarder l'image`)
};

/**

* @param {Even_Top_Javelina_JumpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const even_top_javelina_jump = /** @type {((inputs?: Even_Top_Javelina_JumpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Even_Top_Javelina_JumpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_even_top_javelina_jump(inputs)
});